/**

 * App Guide scenario — fictional Summitlane workspace backed by a sanitized

 * API snapshot (client id c35b8066…). Real company and people names are masked

 * during the tour (Zayo account workspace, Cellhire hotlist hero action).

 */

import {
  TUTORIAL_ZAYO_CONTACT_PERSONAS,
} from "./tutorialPersonas";

export const TUTORIAL_AMC_CLIENT_ID = "c35b8066-2270-405c-b2e0-071cdb0443d6";
export const TUTORIAL_DEFAULT_CAMPAIGN_ID = "ad8f3db8-e563-4e7e-a80b-ecbd7a257604";



export const TUTORIAL_SCENARIO = {

  clientLabel: "Summitlane Marketing Group",

  clientShortLabel: "Summitlane",

  clientDomain: "summitlane.demo",

  primaryAccount: {

    uuid: "2bf9a7ec-6406-4ba7-8e1a-fc88fd3add31",

    name: "Zayo Group",

    shortName: "Zayo",

    domain: "zayo.com",

    industry: "Telecommunications",

  },

} as const;



/** Portfolio accounts on All Accounts + hotlist enrichments (real AMC accounts). */

export const TUTORIAL_DEMO_PORTFOLIO = [

  {

    id: -9001,

    uuid: "2bf9a7ec-6406-4ba7-8e1a-fc88fd3add31",

    name: "Zayo Group",

    domain: "zayo.com",

    industry: "Telecommunications",

    logo_image_url: null,

    num_account_insights: 24,

    num_contacts: 10,

    num_actions: 5,

    has_new_insight: true,

  },

  {

    id: -9002,

    uuid: "3c15093c-af14-42bb-b2e6-2b9f2705ed76",

    name: "Cellhire",

    domain: "cellhire.com",

    industry: "Telecommunications",

    logo_image_url: "https://logo.uplead.com/cellhire.com",

    num_account_insights: 4,

    num_contacts: 3,

    num_actions: 3,

    has_new_insight: true,

  },

  {

    id: -9003,

    uuid: "9cd3eac8-83a3-4372-8a8d-81a3c309bd80",

    name: "Astound Broadband",

    domain: "astound.com",

    industry: "Telecommunications",

    logo_image_url: "https://logo.uplead.com/astound.com",

    num_account_insights: 7,

    num_contacts: 4,

    num_actions: 2,

    has_new_insight: false,

  },

] as const;



/** Zayo account insights (from GET /accounts/{id}). */

export const TUTORIAL_DEMO_INSIGHTS = [

  {

    id: 174466,

    title: "New SVP of Marketing signals a fresh marketing leadership window",

    type: "Leadership",

    score: 89,

    summary:

      `${TUTORIAL_ZAYO_CONTACT_PERSONAS[73334].fullName} joined Zayo as Senior Vice President of Marketing, framing the role around connectivity and AI positioning — a likely near-term review of marketing strategy, messaging, and execution priorities.`,

  },

  {

    id: 174457,

    title: "$8.5B fiber acquisition triggers post-deal integration demands",

    type: "M&A",

    score: 92,

    summary:

      "Zayo completed its acquisition of Crown Castle's fiber business in a transaction valued at $8.5 billion, expanding footprint and creating integration pressure on messaging, portfolio positioning, and sales-marketing alignment.",

  },

  {

    id: 174475,

    title: "AI network buildout and first Mexico PoP signal North American market expansion",

    type: "Expansion",

    score: 87,

    summary:

      "Zayo described a 2025 North American expansion push centered on AI infrastructure, new route miles, and its first-owned PoP in Monterrey, Mexico — alongside the DynamicLink NaaS platform launch.",

  },

] as const;



/** Zayo contacts (from primary-account.json). */

export const TUTORIAL_DEMO_CONTACTS = [

  {

    id: 73334,

    name: TUTORIAL_ZAYO_CONTACT_PERSONAS[73334].fullName,

    title: "Vice President, Business Marketing",

    email: TUTORIAL_ZAYO_CONTACT_PERSONAS[73334].email,

  },

  {

    id: 73332,

    name: TUTORIAL_ZAYO_CONTACT_PERSONAS[73332].fullName,

    title: "Chief Sales Officer (CSO)",

    email: TUTORIAL_ZAYO_CONTACT_PERSONAS[73332].email,

  },

  {

    id: 73333,

    name: TUTORIAL_ZAYO_CONTACT_PERSONAS[73333].fullName,

    title: "Chief Revenue Officer, Enterprise",

    email: TUTORIAL_ZAYO_CONTACT_PERSONAS[73333].email,

  },

] as const;



/** Collateral from GET /assets (AMC library). */

export const TUTORIAL_DEMO_ASSETS = [

  {

    id: 126,

    name: "PAM",

    category: "Key blog",

    updated: "Feb 20, 2026",

  },

  {

    id: 74,

    name: "Making Ugly MDF Pretty Again",

    category: "White paper",

    updated: "Dec 22, 2025",

  },

  {

    id: 73,

    name: "Summitlane Overview",

    category: "White paper",

    updated: "Dec 22, 2025",

  },

] as const;



/** Hotlist hero action — Cellhire account intel email (daily-lists + social prompt). */

export const TUTORIAL_DEMO_HERO_ACTION = {

  action_id: "TLZD7Y5QZuyfb1zS",

  account_id: "3c15093c-af14-42bb-b2e6-2b9f2705ed76",

  account_name: "Cellhire",

  source_insight_id: 165617,

  prompt_id: 383271,

  to_contact_id: 51662,

  series_id: "eaf635ad-d4e9-470e-8318-dfe20759fd70",

  sequence_position: 2,

} as const;

